import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import HelpIcon from '@material-ui/icons/Help';
import FormHelperText from '@material-ui/core/FormHelperText';

import {
  CurrencyInputWrapper,
  FormActionButtons,
  PopoverWrapper
} from 'components';

import { validate } from './validate';

import { useStyles } from './styles';

const initialValues = {
  USD: '0',
  EUR: '0',
  NOK: '0'
};

const PricesFixed = ({
  handleSubmit,
  error,
  anyTouched,
  setSubmitButton,
  isUpdate
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className={classes.currencyRow}>
          <div className={classes.row}>
            <Field
              name={`NOK`}
              label="NOK"
              isHiddenErrorMsg={true}
              className={classes.currencyField}
              component={CurrencyInputWrapper}
            />
            <Field
              name={`EUR`}
              label="EUR"
              isHiddenErrorMsg={true}
              className={classes.currencyField}
              component={CurrencyInputWrapper}
            />
            <Field
              name={`USD`}
              label="USD"
              isHiddenErrorMsg={true}
              className={classes.currencyField}
              component={CurrencyInputWrapper}
            />
            <PopoverWrapper text="Value for at least one currency for each category should be filled in. Currencies marked with zero (or empty) will not be displayed on the widget.">
              <HelpIcon className={classes.helpIcon} />
            </PopoverWrapper>
          </div>
          {anyTouched && error && (
            <FormHelperText error>{t(error)}</FormHelperText>
          )}
        </div>
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'pricesFixedForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(PricesFixed);
